import { ErrorContentGenerator, ErrorContentMap, InvalidFieldMessages } from "./getAlertContent";
import { apiErrorContent as forgotPassword1ApiErrors } from './forgotPassword1Errors';
import { ForgotPassword2AlertProps, ForgotPassword2Fields } from "../../components/SmartErrorAlert";
import { hasErrorMessage } from "../getApiErrorMessage";
import translate from "../translate";

type ForgotPassword2ErrState =
    'notFound' |
    'deactivatedAccount' |
    'wrongAnswer1' |
    'wrongAnswer2' |
    'locked' |
    'unknown';

export const apiErrorContent: ErrorContentMap<ForgotPassword2ErrState> = {
    notFound: forgotPassword1ApiErrors.notFound,
    deactivatedAccount: forgotPassword1ApiErrors.deactivatedAccount,
    unknown: forgotPassword1ApiErrors.unknown,
    wrongAnswer1: {
        header: translate('your_answer_does_not_match_in_records'),
        body: translate('check_anwser_secret_question'),
        analyticsErr: "Your answer doesn’t match our records. Check the answer to your secret question."
    },
    wrongAnswer2: {
        header: translate('your_answer_does_not_match_in_records'),
        body: translate("you_have_one_more_try_reenter_answer"),
        analyticsErr: "Your answer doesn’t match our records. You have 1 more try to re-enter your answer. If it doesn't match our records, your account will be locked to protect your information."
    },
    locked: forgotPassword1ApiErrors.locked
};

// No validation alerts for this step, so this isn't actually used
const invalidFieldMessages: InvalidFieldMessages<ForgotPassword2Fields> = {
    secretAnswer: {
        linkText: 'secret_answer',
        messages: {
            empty: 'enter_answer_to_your_secret_question'
        }
    }
}

export const forgotPasswordStep2ErrorFns = new ErrorContentGenerator<ForgotPassword2AlertProps, ForgotPassword2Fields, ForgotPassword2ErrState, number>({
    apiErrorContent,
    invalidFieldMessages,
    invalidFieldHeader: 'complete_items_to_reset_password', // No validation alerts for this step, so this isn't actually used
    getRefMap: props => {
        return { secretAnswer: props.secretAnswerRef }; // unused for now
    },
    getErrState: (apiResponse, incorrectAnswerCount) => {
        if (!apiResponse) {
            return null;
        }

        switch (apiResponse.code) {
            case 400:
                const { errors } = apiResponse;
                if (!errors) {
                    return 'unknown';
                }
                if (hasErrorMessage(errors, 'did not match')) {
                    return 'notFound';
                }
                if (hasErrorMessage(errors, 'user is disabled')) {
                    return 'deactivatedAccount';
                }
                if (hasErrorMessage(errors, 'locked')) {
                    return 'locked';
                }
                return 'unknown';
            case 403:
                if (incorrectAnswerCount === 0) {
                    return 'wrongAnswer1';
                } else if (incorrectAnswerCount === 1) {
                    return 'wrongAnswer2';
                } else {
                    return 'locked';
                }
            default:
                return 'unknown';
        }
    },
    getApiInvalidFields: () => {
        return [];
    },
    isIntermediateStep: true
});